var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header flex-row flex-center",class:{'collapse-menu': _vm.isMenuCollapse},attrs:{"data-collapse":_vm.menuCollapse}},[_c('nav-bread',{staticClass:"header-breadcrumb"}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-nav flex-row flex-item flex1"},[_c('div',{staticClass:"flex1"})])
}]

export { render, staticRenderFns }